module.exports = __webpack_public_path__ + "static/media/contemplar_te_1.a57b1a8f.jpg";